/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
	* Unauthorized copying of this file, via any medium is strictly prohibited
	* Proprietary and confidential
	* Written by Aetonix, June 19, 2014
	* For information or permission request, email info@aetonixsystems.com
	*/

var Model = require("../types/Model.js");

module.exports = Model({
	name: "surveyautomate",
	listeners: listeners,

	_afterCall: [],
	_managers: [],
	_connecter: null, // _id of who you are connecting to
	_conference_connector: null, // _id of conference call perticipant

	is_manager: is_manager
});

function listeners() {
	return {
		"usersmanagerlist:updated": handle_manager_list,
		"surveysettings:updated": handle_survey_settings,
		"calling:updated": handle_call_update,
		"calling:state:idle": handle_call_ended
	};
}

function handle_manager_list(data) {
	var list = data.map(function(item) {
		return item._id;
	});
	this._managers = list;
}

function handle_survey_settings(settings) {
	if(settings && settings.aftercall)
		this._afterCall = settings.aftercall;
}

function handle_call_update(data) {
	if (data.state !== "connected") return;
	var who = data.who;
	if(who && who._id)
		this._connecter = who._id;

	var conference = data.conference;
	if(conference && conference._id)
		this._conference_connector = conference._id;
}

function handle_call_ended() {
	var connector = this._connecter;
	var conference_connector = this._conference_connector;
	var afterCall = this._afterCall;

	this._connecter = null;
	this._conference_connector = null;

	// Don't try to show the survey if the afterCall setting is empty or missing
	if(!afterCall || !afterCall.length || afterCall[0] === "none") return;

	// Find ID of manager to make the survey from
	var surveyFrom = null;
	if(this.is_manager(connector))
		surveyFrom = connector;
	else if(this.is_manager(conference_connector))
		surveyFrom = conference_connector;

	// Neither person was a manager, so we shouldn't show a survey
	if(!surveyFrom) return;

	afterCall.forEach(show_survey.bind(this, surveyFrom));
}

function show_survey(from, survey) {
	this.api.survey.send(survey, from);
}

function is_manager(id) {
	return this._managers.indexOf(id) !== -1;
}
